module.exports = __webpack_public_path__ + "img/qt-03.1850d047.png";